import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const eachAsync = (source, action) => {
    async function* iterator() {
        for await (const value of source) {
            await action(value);
            yield value;
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
